module.exports = __webpack_public_path__ + "08_face.2e642b68.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer1/08_face.png
// module id = LjrO
// module chunks = 0